import { render, staticRenderFns } from "./CreatePositionPage.vue?vue&type=template&id=d5f9b5d0&scoped=true"
import script from "./CreatePositionPage.vue?vue&type=script&lang=js"
export * from "./CreatePositionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f9b5d0",
  null
  
)

export default component.exports